<template>
  <generic-modal
    size="medium"
    :title="$t('store')"
    icon="store"
    image="/images/icons/store.png"
    :show_ok="true"
    :scrolling="true"
    v-on:destroy="$emit('close')"
    :on_finished="on_finished"
    :footer_buttons="footer_buttons"
    ref="modal"
  >
    <div class="description">
      <div class="ui top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="general"
          ><i class="info icon"></i> {{ $t("general") }}</a
        >
        <a class="item" data-tab="page"
          ><i class="code icon"></i> {{ $t("exchange page") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <general ref="general" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="page">
        <exch ref="exchange" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import General from "./General";
import Exchange from "./Exchange";

export default {
  name: "NvidiaBundleStoreModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    General,
    exch: Exchange,
  },
  computed: {},
  props: {
    selected_store: Object,
  },
  data() {
    return {
      id: "",
      setup: {
        name: "",
        country: "",
        phone_number: "",
        commercial_email: "",
        manager_email: "",
        store_email: "",
        associated_users: "",
        type: "",
        logo: "",
        is_api_active: false,
        is_exchange_page_active: false,
        auto_assign_bundles: false,
        page: { html: "", css: "", js: "" },
      },
      footer_buttons: [
        {
          icon: "trash",
          color: "red",
          text: this.$t("delete"),
          click: this.remove,
        },
      ],
    };
  },
  methods: {
    on_finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let setup = vm.$refs.general.getData();
        setup.logo = vm.$refs.exchange.getData();
        if (vm.$refs.general.isValid()) {
          local_api(vm, "post", "/nvidia_bundle/store/do-save", {
            setup: setup,
            si: vm.id,
          })
            .then(function(r) {
              resolve(r);
              vm.$emit("succedded", vm.setup);
            })
            .catch(function(err) {
              reject(err);
            });
        } else reject();
      });
    },
    remove() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove store?"),
        function() {
          local_api(vm, "post", "/nvidia_bundle/store/do-remove", {
            u: vm.id,
          })
            .then(() => {
              // console.log("graphic card removed");
              vm.$refs.modal.hide();
              // vm.$emit("removed");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {
    let vm = this;
    // window.jQuery(".ui.menu .item").tab();
    // console.log("mountedxx");
    setTimeout(() => {
      if (vm.selected_store) {
        // console.log("init graphic card");
        vm.setup = vm.selected_store.setup;
        if (!vm.setup.page) vm.setup.page = { html: "", css: "", js: "" };
        vm.id = vm.selected_store.store_id;
        vm.$refs.general.setData(vm.setup);
        vm.$refs.exchange.setData(vm.setup);
      }
    }, 100);

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {},
};
</script>
